import formatPercentageWithoutRounding from './formatPercentageWithoutRounding';

export default formatPercentageWithoutRounding;
